import type {Insight} from "../../../models/api/insight/Insight";
import {InsightTypeEnum} from "../../../models/api/insight/InsightTypeEnum";
import {KategorieEnum} from "../../../models/api/insight/KategorieEnum";
import {LizenzEnum} from "../../../models/api/insight/LizenzEnum";

const insights: Array<Insight> = [
    {
        id: "20250722-verbesserungen",
        datum: "22.07.2025",
        kategorie: KategorieEnum.DESKTOP,
        type: InsightTypeEnum.VERBESSERTES_FEATURE,
        title: "Kleinere Verbesserungen",
        lizenz: [LizenzEnum.PRO, LizenzEnum.KURSE],
        content: [
            "<ul>"
            + "<li>👤 Bei den Personendaten kann nun ein Titel / Namenszusatz in einem eigenen Feld erfasst werden. Passend dazu gibt es die Variable $titel für Formulare.</li>"
            + "<li>👤 Bei den Personendaten werden IBAN und BIC beim Speichern validiert und einheitlich angezeigt.</li>"
            + "<li>⚙️ In den Einstellungen zu Rechnungen kann für Dienste / Kurse eine Standard-Zahlungsart gewählt werden.</li>"
            + "<li>📅 Die Kalender-Ausgabe im JSON-Format wurde bei Diensten um die Meldezahlen (Soll- / Ist-Wert und Angabe ob voll besetzt) erweitert.</li>"
            + "<li>📄 Neue Formular-Variablen zur lesbarer gestalteten Ausgabe von Rechnungsposten in LibreOffice-/Word-Vorlagen für Rechnungen.</li>"
            + "<li>🎓 Eine Markierung mit % zeigt in der TN-Liste an, wenn der Steuersatz der Teilnahme noch nicht gesetzt wurde.</li>"
            + "<li>📄 Neue Variable $tn_rech_nr_1 zur Ausgabe der Rechnungsnummer der Teilnahme auf Formularen.</li>"
            + "<li>📤️ Die Export-Funktion der Kursliste (Menü Kurse > Liste) wurde um das Format <a href='https://www.fortbildung-bw.de/kurserfassung/KursML/' target='_blank'>KursML</a> erweitert.</li>"
            + "<li>📤️ Beim Material-Export werden bei Fahrzeugen nun Baujahr und Erstzulassung mit ausgegeben.</li>"
            + "</ul>",
        ],
        aktions: [],
    }
];

export {
    insights,
};
